module.exports = __webpack_public_path__ + "static/media/YB5M13_0.41e9f520.jpg";